import router from '@/router'

export default redirect => {
  router.addRoute({
    path: '/',
    name: 'default',
    redirect
  })
}
